import module from 'cliente/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class ClienteInformacionJuridicoDocumentosComponent {
  idCliente
  seleccionando = false
  procesando = false
  data = null
  documentos = null

  constructor ($fileSystem, $q, CatalogoClientesDocumentos, ClienteInformacionJuridicoDocumentos) {
    this.$fileSystem = $fileSystem
    this.$q = $q
    this.CatalogoClientesDocumentos = CatalogoClientesDocumentos
    this.ClienteInformacionJuridicoDocumentos = ClienteInformacionJuridicoDocumentos
  }

  $onInit () {
    return this.$q.all([
        this.ClienteInformacionJuridicoDocumentos.get(this.idCliente)
          .then(({data}) => (this.data = orderBy(data, ['name']))),
        this.CatalogoClientesDocumentos.get({agrupacion: 'juridico'})
          .then(({data}) => (this.documentos = data)),
      ])
      .then(() => (this.filtrarLista()))
  }

  agregar (idDocumento) {
    if (this.procesando) return

    this.procesando = true

    return this.$fileSystem.select(false, 'application/pdf')
      .then((files) => {
        return this.ClienteInformacionJuridicoDocumentos.post(this.idCliente, {idDocumento: idDocumento, documento: files[0]})
          .then(({data}) => {
            this.data = orderBy(this.data.concat(data), ['name'])
            this.filtrarLista()
          })
          .finally(() => (this.procesando = false))
      })
      .finally(() => (this.seleccionando = false))
  }

  eliminar (item) {
    return this.ClienteInformacionJuridicoDocumentos.delete(item.id_cliente, item.id_documento, item.indice)
      .then(() => {
        this.data.splice(this.data.indexOf(item), 1)
        this.filtrarLista()
      })
  }

  link (item) {
    return this.ClienteInformacionJuridicoDocumentos.link(item.id_cliente, item.id_documento, item.indice)
  }

  filtrarLista () {
    const index = this.data.map((item) => Number(item.id_documento))
    this.lista = this.documentos.filter((item) => index.indexOf(item.id) < 0)
  }
}

module.component('clienteInformacionJuridicoDocumentos', {
  controller: ClienteInformacionJuridicoDocumentosComponent,
  template,
  bindings: {
    idCliente: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/juridico/documentos/component.js